import React from "react";

import image from "../assets/avatars.png";

import { FaGithub, FaInstagram, FaLinkedin } from "react-icons/fa";

import { TypeAnimation } from "react-type-animation";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";

const Banner = () => {
  return (
    <section
      className="min-h-[85vh] lg:min-h-[78vh] flex items-center"
      id="home"
    >
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-8 lg:flex-row">
          {/* {text} */}
          <div className="flex-1 text-center font-secondary lg:text-left">
            <motion.h1
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{
                once: false,
                amount: 0.7,
              }}
              className="text-[40px] font-bold leading-[0.8] lg:text-[60px]"
            >
              Christian <span>Yuda Pratama </span>
            </motion.h1>
            <motion.div
              variants={fadeIn("up", 0.4)}
              initial="hidden"
              whileInView={"show"}
              viewport={{
                once: false,
                amount: 0.7,
              }}
              className="mb-6 text-[36px] lg:text-[50px] font-secondary
             font-semibold uppercase leading-[1]"
            >
              <span className="text-white mr-4">I am a</span>
              <TypeAnimation
                sequence={[
                  "Developer",
                  2000,
                  "Designer",
                  2000,
                  "Front end",
                  2000,
                ]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn("up", 0.5)}
              initial="hidden"
              whileInView={"show"}
              viewport={{
                once: false,
                amount: 0.7,
              }}
              className="mb-8 max-w-lg mx-auto lg:mx-0"
            >
              Dengan keahlian saya dalam desain dan semangat saya sebagai web
              developer, saya merangkai sentimen-sentimen menjadi kode-kode yang
              menawan. Melalui bahasa pemrograman, saya menciptakan pengalaman
              visual yang khas, memadukan keindahan dengan fungsionalitas.
              Sebagai seorang front-end developer, saya merangkul desain sebagai
              bahasa utama, membangun antarmuka yang menarik dan memikat hati
              pengguna.
            </motion.p>
            <motion.div
              variants={fadeIn("up", 0.6)}
              initial="hidden"
              whileInView={"show"}
              viewport={{
                once: false,
                amount: 0.7,
              }}
              className="flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0"
            >
              <button className="btn btn-lg">Contact me</button>
              <a href="#" className="text-gradient btn-link">
                My Portofolio
              </a>
            </motion.div>
            {/* {social} */}
            <motion.div
              variants={fadeIn("up", 0.7)}
              initial="hidden"
              whileInView={"show"}
              viewport={{
                once: false,
                amount: 0.7,
              }}
              className="flex text-[30px] gap-x-6 max-w-max mx-auto lg:mx-0"
            >
              <a href="#">
                <FaInstagram />
              </a>
              <a href="https://github.com/christyuda">
                <FaGithub />
              </a>
              <a href="#">
                <FaLinkedin />
              </a>
            </motion.div>
          </div>

          <motion.div
            variants={fadeIn("down", 0.8)}
            initial="hidden"
            whileInView={"show"}
            viewport={{
              once: false,
              amount: 0.7,
            }}
            className="hidden lg:flex flex-1 max-w-[260px] lg:max-w-[482px]"
          >
            <img src={image} alt=""></img>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
